import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  IgCopyTextTypography,
  IgDialog,
  IgDivider,
  IgTypography,
} from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";
import { shortId } from "@intelligems/ig-utils";
import { Grid } from "@mui/material";

import { isDialogOpen, setDialog } from "../../store/slices/global";

interface ExperienceTestInfoProps {
  experience: ExperienceDto;
}

export const ExperienceTestInfo = ({ experience }: ExperienceTestInfoProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("experimentInfo"));

  const onIdCopy = async (id: string, testGroupName?: string) => {
    await navigator.clipboard.writeText(id);
    toast.success(
      `${testGroupName ?? "Experiment"} ${
        id.length === 12 ? "GA" : ""
      } ID Copied`
    );
  };

  return (
    <IgDialog
      showCloseIcon={true}
      hideActions={true}
      title={`${experience.name} Information`}
      handleClose={() => {
        dispatch(
          setDialog({
            dialog: "experimentInfo",
            open: false,
          })
        );
      }}
      showDialog={isOpen}
      dialogContentWidth={"440px"}
      maxWidth={"lg"}
      dialogHeight={null}
      rawContent={
        <Grid
          container
          direction={"column"}
          id={"experiment-info-dialog-content"}
          rowSpacing={1.5}
        >
          <Grid item>
            <IgTypography igStyle={"semibold"}>
              Experiment ID:{" "}
              <IgCopyTextTypography
                text={experience.id!}
                toastMessage={(text) => void onIdCopy(text)}
              />
            </IgTypography>
          </Grid>
          <Grid item>
            <IgDivider />
          </Grid>
          {experience.variations.map((variation) => (
            <Grid item key={variation.id}>
              <IgTypography igStyle={"semibold"}>
                {variation.name} ID:{" "}
                <IgCopyTextTypography
                  text={variation.id}
                  toastMessage={(text) => void onIdCopy(text, variation.name)}
                />
                <br />
                <IgTypography igStyle={"semibold"}>For GA: </IgTypography>
                <IgCopyTextTypography
                  text={shortId(variation.id!)}
                  toastMessage={(text) => void onIdCopy(text, variation.name)}
                />
              </IgTypography>
            </Grid>
          ))}
        </Grid>
      }
    />
  );
};
